const PAIRS = [
  {
    label: "Küchenoberfläche",
    before:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/7f26333ceb780a776279d7fa1ebde18f7b02747445dffd17028f86a332c7c4ca.png",
    beforeAlt: "Dieselbe Küchenoberfläche mit Fett und Unordnung vor der Reinigung",
    after:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/89f61f74a3c183dd1a65d6cdc1ee55247c8fc758b4c8820e9eb0fcc9c0f7acbe.png",
    afterAlt: "Dieselbe Küchenoberfläche sauber und aufgeräumt nach der Reinigung",
  },
  {
    label: "Büro",
    before:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/1d7d475b6014d0abe2cbe7b996a1c1ab5acaa09f364bdbfc46c716583e899b80.png",
    beforeAlt: "Derselbe Büroarbeitsplatz staubig und unordentlich vor der Reinigung",
    after:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/460166efdf8b6c75089e5a6b7354d083fa1839202e5c3637fb97964940140617.png",
    afterAlt: "Derselbe Büroarbeitsplatz sauber und ordentlich nach der Reinigung",
  },
  {
    label: "Boden",
    before:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/271d345fddb56e4f3954183944a427f08be49d4158c5243dd734ce49990aef2a.png",
    beforeAlt: "Derselbe Fliesenboden mit Schmutz und Staub vor der Reinigung",
    after:
      "https://static.prod-images.emergentagent.com/jobs/bf3da119-29b3-4fa7-b192-937ca20ead68/images/b70589812e1dd402f41f59fa96e058f9bce17a1cdd9d6bf77d64e6b29ff54cf9.png",
    afterAlt: "Derselbe Fliesenboden sauber und glänzend nach der Reinigung",
  },
];

const Frame = ({ src, alt, tag, tagColor }) => (
  <div className="relative flex-1 overflow-hidden rounded-xl">
    <img src={src} alt={alt} width="632" height="424" loading="lazy" decoding="async" className="h-40 w-full object-cover" />
    <span
      className={`absolute top-2 left-2 rounded-full px-3 py-1 text-xs font-bold text-white ${tagColor}`}
    >
      {tag}
    </span>
  </div>
);

export const BeforeAfter = () => {
  return (
    <section data-testid="before-after-section" className="py-24 md:py-32 bg-[#F8FAFC]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#0077E6] mb-4">
            Ergebnisse
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-[#0A192F]">
            Vorher &amp; Nachher
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {PAIRS.map((p, i) => (
            <div
              key={p.label}
              data-testid={`before-after-${i}`}
              className="bg-white p-4 rounded-2xl border border-slate-100 shadow-[0_8px_30px_rgb(10,25,47,0.04)]"
            >
              <div className="flex gap-3">
                <Frame
                  src={p.before}
                  alt={p.beforeAlt}
                  tag="Vorher"
                  tagColor="bg-slate-500/90"
                />
                <Frame
                  src={p.after}
                  alt={p.afterAlt}
                  tag="Nachher"
                  tagColor="bg-[#0077E6]"
                />
              </div>
              <p className="mt-4 text-center text-base font-semibold text-[#0A192F]">
                {p.label}
              </p>
            </div>
          ))}
        </div>

        <p
          data-testid="before-after-note"
          className="mt-8 text-sm text-slate-500"
        >
          Beispielhafte Darstellung
        </p>
      </div>
    </section>
  );
};
